module.exports = __webpack_public_path__ + "52315047a7f32479afe5ebaad0654962.png";